module.exports = __webpack_public_path__ + "img/4.2c9b0fa8.jpg";